// export const COLS = 2;
// export const ROWS = 2;
// export const COLS = 25;

export const LINN128 = 128;
export const LINN200 = 200;

export const DIMENSIONS: { [model: number]: { rows: number; cols: number }} = {
    [LINN128]: {
        cols: 16,
        rows: 8
    },
    [LINN200]: {
        cols: 25,
        rows: 8
    }
}

// export const LINN_COLS = 26; // one column for the control switches + 25 columns for the notes
export const LINN_COLS = 17; // one column for the control switches + 16 columns for the notes
export const LINN_ROWS = 8;
export const LINN_COL_OFFSET = 1; // one column for the control switches + 25 columns for the notes


export const COLOR_OFF = 0;
export const COLOR_RED = 1;
export const COLOR_YELLOW = 2;
export const COLOR_GREEN = 3;
export const COLOR_CYAN = 4;
export const COLOR_BLUE = 5;
export const COLOR_MAGENTA = 6;
// export const COLOR_BLACK = 7;
export const COLOR_WHITE = 8;
export const COLOR_ORANGE = 9;
export const COLOR_LIME = 10;
export const COLOR_PINK = 11;

export const COLORS: { [code: number]: string } = {
    [COLOR_OFF]:     'off',
    [COLOR_RED]:     'red',
    [COLOR_YELLOW]:  'yellow',
    [COLOR_GREEN]:   'green',
    [COLOR_CYAN]:    'cyan',
    [COLOR_BLUE]:    'blue',
    [COLOR_MAGENTA]: 'magenta',
    // [COLOR_BLACK]:    'transp.',
    [COLOR_WHITE]:   'white',
    [COLOR_ORANGE]:  'orange',
    [COLOR_LIME]:    'lime',
    [COLOR_PINK]:    'pink'
}
/*
export const COLORS = {
    'off' : COLOR_OFF,
    'red' : COLOR_RED,
    'yellow' : COLOR_YELLOW,
    'green' : COLOR_GREEN,
    'cyan' : COLOR_CYAN,
    'blue' : COLOR_BLUE,
    'magenta' : COLOR_MAGENTA,
    // 'transp.' : COLOR_BLACK,
    'white' : COLOR_WHITE,
    'orange' : COLOR_ORANGE,
    'lime' : COLOR_LIME,
    'pink' : COLOR_PINK
}
*/
